import { Grid, Typography } from '@mui/material'
import Logo from '../assets/images/K2GLogo2.svg';
import LogoWhite from "../assets/images/K2GLogoWhite.png";

const BannerReportTIM = ({text, image=false,bgColor="#0F5385"}) => {
    return (
    <Grid container sx={{alignItems:"stretch", backgroundColor:bgColor}}>
        <Grid size={image?{xs:12,sm:10}:12} display={"flex"} justifyContent={"center"} flexDirection={"column"} alignItems={image?{xs:"center",sm:"flex-start"}:"center"} sx={{padding:{xs:"20px 16px",sm:"24px 24px",md:"24px 48px"}}}>
            <Typography variant="h4" fontWeight={600} color="white" sx={{wordBreak:"break-word",fontSize:{xs:"1.5rem",sm:"1.75rem",md:"2.125rem"}}} dangerouslySetInnerHTML={{ __html: text }}/>
        </Grid>
        {
            image &&
            <Grid size={{xs:12,sm:2}} display={"flex"} justifyContent={"center"} alignItems={"center"} sx={{padding:{xs:"0 16px 16px",sm:"16px 24px"}}}>
                <img src={LogoWhite} alt="LOGO" style={{width:"120px",maxWidth:"100%"}}/>
            </Grid>
        }
    </Grid>
    )
}

export default BannerReportTIM